import { url_ippica } from 'components/SwitchTableMovements/partials/TableBets/TableBets.config';
import escapeRegexSpecialCharacters from 'utils/functions/escapeRegexSpecialCharacters';
import { createScopedErrorHandler } from 'utils/functions/handleError';
import injectScript from 'utils/functions/injectScript';
import { mapFormNameToCanonicalName } from './SwitchTableMovements.config';

export async function injectIppicaScript() {
  // Ippica script requires 'jQuery' on the global scope.
  if ((window as any).jQuery == null) {
    await injectScript('https://code.jquery.com/jquery-3.5.0.min.js');
  }

  return injectScript(url_ippica);
}

export const handleMovementsTableError = createScopedErrorHandler(
  'switch-table-movements',
);

export function transformFormValuesToCanonicalNames<
  T extends Record<string, JSONData>,
>(values: T) {
  return Object.fromEntries(
    Object.entries(values).map(([key, val]) => {
      let nextKey = key;

      if (key in mapFormNameToCanonicalName) {
        nextKey =
          mapFormNameToCanonicalName[
            key as keyof typeof mapFormNameToCanonicalName
          ];
      }
      return [nextKey, val];
    }),
  );
}

export function supportedAllMovementRegexTest(
  list: ListboxOption[],
  params: string,
) {
  return new RegExp(
    `^(?:${list
      .map((period) => escapeRegexSpecialCharacters(period.optionId + ''))
      .join('|')})$`,
    'i',
  ).test(params);
}

export const ticketSomething: Partial<{
  scratchAndWin: (
    contestId: string,
    billCode: string,
    token: string,
    transactionId: string,
    idRivenditore: string,
  ) => void;
  lotteryItaly: (
    drawId: string,
    billCode: string,
    token: string,
    transactionId: string,
    idRivenditore: string,
  ) => void;
}> = {};
